import { useEffect, useState } from 'react';
import find from 'lodash/find';
import get from 'lodash/get';
import zipObject from 'lodash/zipObject';

const zipAttributes = attributes =>
  zipObject(
    attributes.map(attribute => attribute.attribute_code),
    attributes.map(attribute => attribute.value)
  );

const buildURLQuery = query =>
  Object.entries(query)
    .map(pair => pair.map(encodeURIComponent).join('='))
    .join('&');

const useFetchProducts = (
  category = 'materials',
  storeId = null,
  vertical = 'flat'
) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const baseUrl = `${
    process.env.RAZZLE_MAGENTO_URL
  }/rest/${storeId}/V1/storefront/getitemsbypath`;

  const fetchOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  };

  const qs = buildURLQuery({
    path: category,
    depth: '2',
    vertical
  });
  const url = `${baseUrl}?${qs}`;

  async function fetchData() {
    const response = await fetch(url, fetchOptions);
    const json = await response.json();

    const categoryName = get(json, 'category.name', null);
    const categoryId = get(json, 'category.id', null);
    const products = get(json, 'category.product_children', null);

    if (!categoryName || !products) {
      setData(null);
      setLoading(false);
      return;
    }

    const transformedProducts = products.map(product => ({
      ...product,
      attributes: zipAttributes(product.custom_attributes), // transform to dict
      position: get(
        // extract position in category
        find(get(product, 'extension_attributes.category_links', []), {
          category_id: `${categoryId}`
        }),
        'position',
        0
      )
    }));

    setData(transformedProducts);
    setLoading(false);
  }

  useEffect(
    () => {
      setLoading(true);
      if (storeId) {
        fetchData();
      }
    },
    [category, storeId, vertical]
  );

  return { loading, data };
};

export default useFetchProducts;
